import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';

import { myLocalStorage } from './myLocalStorage';
//Import all translation files
import translationEnglish from './translation/en.json';
import translationSpanish from './translation/es.json';
import translationFrench from './translation/fr.json';

const resources = {
  en: {
    translation: translationEnglish,
  },
  es: {
    translation: translationSpanish,
  },
  fr: {
    translation: translationFrench,
  },
};

let defaultLanguage = myLocalStorage.getItem('language') || 'en';
if (['en', 'es', 'fr'].includes(defaultLanguage) === false) {
  defaultLanguage = 'en';
}

i18next.use(initReactI18next).init({
  resources,
  lng: defaultLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

document.documentElement.lang = i18next.language;

export default i18next;
